"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlChargingPortStateValidation = void 0;
const ChargerPortStateValidation_1 = require("./ChargerPortStateValidation");
class ChargerControlChargingPortStateValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // Validate entity.port_state for existence and correct type.
        if (entity.port_state == undefined)
            return false;
        if (!ChargerPortStateValidation_1.ChargerPortStateValidation.isValid(entity.port_state))
            return false;
        // Validate entity.p_dc_kw for existence and correct type.
        if (entity.p_dc_kw == undefined)
            return false;
        if (typeof entity.p_dc_kw !== "number")
            return false;
        // Validate entity.i_dc_a for existence and correct type.
        if (entity.i_dc_a == undefined)
            return false;
        if (typeof entity.i_dc_a !== "number")
            return false;
        // Validate entity.v_dc_v for existence and correct type.
        if (entity.v_dc_v == undefined)
            return false;
        if (typeof entity.v_dc_v !== "number")
            return false;
        // Validate entity.vehicle_soc for existence and correct type.
        if (entity.vehicle_soc == undefined)
            return false;
        if (typeof entity.vehicle_soc !== "number")
            return false;
        // Validate entity.energy_delivered for existence and correct type.
        if (entity.energy_delivered == undefined)
            return false;
        if (typeof entity.energy_delivered !== "number")
            return false;
        // If entity.plugged_in exists, validate that it has the correct type.
        if (entity.plugged_in != undefined) {
            if (typeof entity.plugged_in !== "boolean")
                return false;
        }
        // If entity.reset_expires_at exists, validate that it has the correct type.
        if (entity.reset_expires_at != undefined) {
            if (!(entity.reset_expires_at instanceof Date))
                return false;
        }
        // If entity.totalizer_kwh exists, validate that it has the correct type.
        if (entity.totalizer_kwh != undefined) {
            if (typeof entity.totalizer_kwh !== "number")
                return false;
        }
        return true;
    }
}
exports.ChargerControlChargingPortStateValidation = ChargerControlChargingPortStateValidation;
